"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encryptOrDecryptObject = exports.encryptOrDecrypt = exports.encryptDecryptString = exports.initializeAndLoadKey = void 0;
var crypto_js_1 = __importDefault(require("crypto-js"));
var get_document_data_1 = __importDefault(require("../get-document-data"));
var key;
/**
 * Loads encryption key from dbRef, and caches for later use.
 * @param dbRef Reference to the encryption key in firestore
 * @param options encrypt: Set true to encrypt. decrypt: Set true to decrypt
 * @returns
 */
function initializeAndLoadKey(dbRef, options) {
    if ((!options.encrypt && !options.decrypt) || (options.encrypt && options.decrypt))
        return Promise.reject(new Error("EconsultCrypto error: Must provide one of encrypt or decrypt in options"));
    return new Promise(function (resolve, reject) {
        if (!key) {
            dbRef.get().then(get_document_data_1.default)
                .then(function (data) {
                key = data.key;
                resolve(key);
            })
                .catch(function (error) {
                reject(error);
            });
        }
        else {
            resolve(key);
        }
    });
}
exports.initializeAndLoadKey = initializeAndLoadKey;
/**
 * Wrapper for encryptOrDecrypt that handles encryption key loading from dbRef
 * @param str String to encrypt or decrypt
 * @param dbRef Reference to the encryption key in firestore
 * @param options encrypt: Set true to encrypt. decrypt: Set true to decrypt
 * @returns Encrypted or decrypted string
 */
function encryptDecryptString(str, dbRef, options) {
    return initializeAndLoadKey(dbRef, options)
        .then(function (key) {
        return encryptOrDecrypt(str, key, options);
    });
}
exports.encryptDecryptString = encryptDecryptString;
/**
 *
 * @param val String to encrypt or decrypt
 * @param key Encryption key
 * @param options encrypt: Set true to encrypt. decrypt: Set true to decrypt
 * @returns Encrypted or decrypted string
 */
function encryptOrDecrypt(val, key, options) {
    if (options.encrypt)
        return crypto_js_1.default.AES.encrypt(val, key).toString();
    else if (options.decrypt)
        return crypto_js_1.default.AES.decrypt(val, key).toString(crypto_js_1.default.enc.Utf8);
    else
        return ""; //Should never happen, since calling function will throw error if neither option is selected
}
exports.encryptOrDecrypt = encryptOrDecrypt;
/**
 * Encrypted or decrypts an object. Optionally, encrypt or decrypt the keys in the object
 * @param subObj Object to encrypt or decrypt
 * @param key encrypt: Set true to encrypt. decrypt: Set true to decrypt
 * @param options encrypt: Set true to encrypt. decrypt: Set true to decrypt
 * @param encryptOrDecryptFieldNames If true, will encrypt or decrypt object field names as well
 * @returns Encrypted or decrypted objecct
 */
function encryptOrDecryptObject(subObj, key, options, encryptOrDecryptFieldNames) {
    if (subObj.constructor === ({}).constructor) { //Encrypt field names if subObj is an object
        var newObj_1 = {};
        Object.keys(subObj).forEach(function (field) {
            var newField;
            if (encryptOrDecryptFieldNames)
                newField = encryptOrDecrypt(field, key, options);
            else
                newField = field;
            newObj_1[newField] = encryptOrDecryptObject(subObj[field], key, options, encryptOrDecryptFieldNames);
        });
        return newObj_1;
    }
    else if (typeof subObj === "string") { //Encrypt string value if subObj is a string
        return encryptOrDecrypt(subObj, key, options);
    }
    else { //Otherwise just return (only other case is this is a boolean which can't be encrypted)
        return subObj;
    }
}
exports.encryptOrDecryptObject = encryptOrDecryptObject;
//# sourceMappingURL=crypto.js.map